import { Pipe, PipeTransform } from '@angular/core';
import { WorkContact, WorkContactPerson, WorkProspect, WorkReservation } from '@work-frontend-monorepo/work-rest-api';

@Pipe({
  name: 'getFullnameOfContact',
  standalone: true,
})
export class GetFullnameOfContactPipe implements PipeTransform {
  transform(contact?: WorkContact | WorkReservation | WorkContactPerson | WorkProspect | null, excludeCompany = false): string {
    if (!contact) {
      return '';
    }

    const company = 'company' in contact ? contact.company : undefined;
    const person = [contact.firstName, contact.lastName].filter(Boolean).join(' ');

    if (!excludeCompany && company) {
      return person ? `${company}, ${person}` : company;
    }

    return person;
  }
}
